import { ACLStateConstants } from "redux_constants/acl.constant";


const getInitialACLState = () => ({
  allPolicies:[],
  allPermissions: [],
});


export const initialACLState = {
  allPolicies: [],
  allPermissions: [],
  allPermissionCategories: []
};

export const aclReducer = (state = getInitialACLState(), action) => {    
    const updatedState = Object.assign({}, state)

    switch(action.type) {
        case ACLStateConstants.SET_ACL_STATE:
            Object.assign(updatedState, action.aclState || {})
            return updatedState

        case ACLStateConstants.UPDATE_ALL_ACL_PERMISSIONS:
            Object.assign(updatedState, { "allPermissions": action["allPermissions"] })
            return updatedState

        case ACLStateConstants.UPDATE_ALL_ACL_POLICIES:
            Object.assign(updatedState, { "allPolicies": action["allPolicies"] })
            return updatedState

        case ACLStateConstants.UPDATE_ALL_ACL_PERM_CATEGORIES:
            Object.assign(updatedState, { "allPermissionCategories": action["allPermCategories"]  })
            return updatedState

        case ACLStateConstants.CLEAR_ACL_STATE:
            return initialACLState

        case ACLStateConstants.UPDATE_ACL_PERMISSIONS:
            Object.assign(updatedState, action.permissions || {});
            return updatedState

        case ACLStateConstants.UPDATE_ACL_GROUPS:
            Object.assign(updatedState, action.policies || {})
            return updatedState;

        default:
            return state
    }
}